module.exports = __webpack_public_path__ + "img/1441266901.4da8be75.jpg";